module.exports = __webpack_public_path__ + "static/bg_texture-94d2b4e34240813a3c74ab3c227325c0.png";